import React from 'react';
import ReactDOM from 'react-dom/client';
import './app-background.css';
import './index.css';

// Conditional app loading based on environment
const App = process.env.REACT_APP_SITE === 'vjb'
  ? require('./vjb/App').default
  : require('./App').default;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);